import React from 'react';
import { useAuth } from '../../context/AuthContext';

export function ReadOnlyBanner() {
  const { signOut } = useAuth();

  const handleSubscribe = () => {
    window.LemonSqueezy?.Url?.Open(
      'https://222fasting.lemonsqueezy.com/checkout/buy/33bc7edb-1a1a-4492-8d33-bc2badc66ecd?embed=1'
    );
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-error-container/10 border-b border-error-container p-4 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="flex-shrink-0 text-error">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <div>
          <p className="text-base font-medium text-error">
            Your access has ended. Upgrade to continue.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <button
          onClick={handleSubscribe}
          className="px-4 py-2 rounded-lg bg-error hover:bg-error/90 text-white font-medium transition-colors"
        >
          Subscribe
        </button>
        <button
          onClick={signOut}
          className="px-4 py-2 rounded-lg bg-surface-container hover:bg-surface-container-hover text-on-surface font-medium transition-colors"
        >
          Log Out
        </button>
      </div>
    </div>
  );
}
